<template>
  <div class="design_form">
    <p class="design_form_title">{{property.title}}</p>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {};
  }
};
</script>
